import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-204">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" onClick={onClose} data-id="element-205" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="fixed inset-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:max-w-2xl md:w-full md:max-h-[80vh] bg-[#141414] border border-[#D4AF37]/30 rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-206">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-[#D4AF37]/20" data-id="element-207">
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-208">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 transition-colors" data-id="element-209">
                <X className="w-5 h-5 text-gray-400" data-id="element-210" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6" data-id="element-211">{children}</div>
          </motion.div>
        </>}
    </AnimatePresence>;
}